







import { Component, Vue } from 'vue-property-decorator'
import { REGULATION_ROLE } from '@/class/const'
import SmallCardList from '@/components/Common/Card/SmallCardList.vue'
import HeadlineBorder from '@/components/Utils/headline/HeadlineBorder.vue'

@Component({
  components: {
    SmallCardList,
    HeadlineBorder
  }
})
export default class AllRoleGuide extends Vue {
  get roleIds () {
    return Object.keys(REGULATION_ROLE)
  }
}
